import apiClient from './apiClient';

// Order service — mirrors r2b-restaurant-mobile-new/src/services/orderService.js.

export const getBranchOrders = async (branchId, query = {}) => {
  const response = await apiClient.get(`/orders/${branchId}`, { params: query });
  return response.data;
};

export const getAllOrders = async (query = {}) => {
  const response = await apiClient.get('/orders', { params: query });
  return response.data;
};

export const getOrderById = async (orderId) => {
  const response = await apiClient.get(`/order/${orderId}`);
  return response.data;
};

export const updateOrderStatus = async (orderId, status, note = '') => {
  const response = await apiClient.put(`/order/${orderId}/status`, { status, note });
  return response.data;
};

export const cancelOrder = async (orderId, cancellationStatus, cancelledBy) => {
  const response = await apiClient.post(`/order/${orderId}/cancel`, {
    cancellationStatus,
    cancelledBy,
  });
  return response.data;
};

export const rejectOrder = async (orderId, rejectionReason, cancellationStatus = 'beforePreparation') => {
  const response = await apiClient.post(`/order/${orderId}/reject`, {
    rejectionReason,
    cancellationStatus,
  });
  return response.data;
};

export const createManualOrder = async (orderData) => {
  const response = await apiClient.post('/order/manual', orderData);
  return response.data;
};
